import React, { Fragment } from 'react'
import { IconClose } from 'components/Zui/Icon'
import { useIntl } from 'hooks'
import Users from 'features/users/Users'
import './settings.css'

const Index = ({ onClose }) => {
    const { t } = useIntl()

    return (
        <Fragment>
            <div className="settings-wrapper">
                <div className="setting-header-wrapper">
                    <div className="setting-header-title">
                        <span>{t('settings')}</span>
                    </div>
                    <div className="close-setting-wrapper" onClick={onClose}>
                        <div className="user-settings-close-button">
                            <IconClose size="m" className="close-setting-icon" />
                        </div>
                    </div>
                </div>
                <div className="settings-details-wrapper">
                    <Users />
                </div>
            </div>
        </Fragment>
    )
}

export default Index
